import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';

@OpenApiMethod({
  method: HttpMethods.DELETE,
  apiName: 'customer',
  path: '/profile',
  operationId: 'ProfileController_delete',
  parameters: [],
})
export class ProfileControllerDeleteMethod extends BaseOpenApiMethod<void> implements Method<void, void> {
  public call(): Promise<void> {
    return super.call();
  }
}
